import { css } from 'styled-components';
export var fontSmoothing = css(["-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;"]);